<template>
  <div class="toolbar-container">
    <div class="toolbar-wrap">
      <div class="toolbar-wrap-left">
        <v-btn icon v-if="showBackButton" @click="handleBackClick" >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div class="navbar-title">
          <h4>{{ title }}</h4>
        </div>
      </div>
      <div class="selectbox-container" >
      </div>
    </div>
      
  </div>
</template>
    
<script >
import ReloadIcon from '@/assets/ReloadIcon.vue';

  export default{
      name: 'NavigationBar',
      components: {
          ReloadIcon,
      },
      props: {
          title: {
              type: String,
              required: true,
          },
          showBackButton : {
              type : Boolean,
              default : false
          },
          showReloadButton : {
              type : Boolean,
              default : false
          },
          isReloading : {
              type : Boolean,
              default : false
          }
      },
      data() {
        return {
          selectedLanguage: 'Eng',
          langs: ['Eng', 'Myn'],
        };
      },
      mounted(){
        this.selectedLanguage = this.langs[0];
      },
      methods : {
        changeLanguage() {
          console.log('changed');
        },

        handleBackClick() {
          this.$emit('on-back-button-click');
        },

        reloadAppointments() {
          this.$emit('reload-appointments');
        }
      }
  }
</script>
  
  <style>
      .reload-icon {
        cursor: pointer;
        width: 28px;
        height: 28px;
      }
      .reload-icon:hover {
        color: #1976D2;
      }
      .toolbar-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
        background-color: #ffffff;
        border-bottom: 1px solid #E0E0E0;
      }

      .navbar-title{
        font-weight: 700;
      }

      .v-input {
        font-weight: 500;
      }

      .navbar-title .v-toolbar__title {
        font-size: 16px;
        color: #333333;
        line-height: 16px;
      }
     .selectbox-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
     }
     .v-text-field > .v-input__control > .v-input__slot:before, .v-text-field > .v-input__control > .v-input__slot:after {
        width: 0 !important;
     }

     .v-toolbar__content {
        padding : 16px 20px;
     }

     .v-sheet.v-toolbar:not(.v-sheet--outlined) {
      /* box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12); */
      border-bottom: 1px solid #E0E0E0;
      box-shadow: none;
    }

    .toolbar-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      height: 56px;
    }

    .toolbar-wrap-left {
      display: flex;
      align-items: center;
    }

    .reload-icon {
        transition: transform 0.3s ease;
    }

    .reload-icon.is-reloading {
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }
     
  </style>
  
  
  
  
  
  
  
  